import { createTheme, DEFAULT_THEME, mergeMantineTheme } from '@mantine/core'
import { generateColors } from '@mantine/colors-generator'

const themeOverride = createTheme({
  primaryColor: 'blue',
  cursorType: 'pointer',
  black: '#212529',
  defaultRadius: 'sm',
  focusRing: 'never',
  activeClassName: 'active',
  colors: {
    'navbar-blue': [
      '#92B5D4',
      '#264C6E',
      '#244868',
      '#1C3750',
      ...Array(6).fill('#1A334A'),
    ] as any,
  },
})

export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride)
